import { ssmRouterGuardService } from "@/shared/services/router-guard-service";
import Vue from "vue";
import Router from "vue-router";
import { RouterNames } from "./routernames";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/main",
    },
    {
      path: "*",
      redirect: "/main",
    },
    {
      path: "/login",
      name: RouterNames.Login,
      component: () => import("@/views/login/login-formulario.vue"),
    },
    {
      path: "/lostpwd",
      name: RouterNames.lostpwd,
      component: () => import("@/views/lostpwdforms/pswlost.vue"),
    },
    {
      path: "/confirm-new-password/:token",
      name: RouterNames.confirm_new_password,
      component: () => import("@/views/lostpwdforms/pwdlost-confirm.vue"),
    },
    {
      path: "/instalacion",
      name: RouterNames.instalacion,
      component: () => import("@/views/instalacion/instalacion.vue"),
    },
    {
      path: "/cuadros_de_mando",
      name: RouterNames.cuadros_de_mando,
      component: () =>
        import("@/views/mainlayout_sinlogin/main-layout-sin-login.vue"),
      children: [
        {
          path: "tipos",
          name: RouterNames.tipos_dash_sin_login,
          meta: { show_btns: "false" },
          component: () => import("@/views/home/selectsheet_sin_login.vue"),
        },
        {
          path: "Dash/:id",
          name: RouterNames.Dash_sin_login,
          meta: { show_btns: "false" },
          component: () => import("@/views/home/dashboard_by_group.vue"),
        },
      ],
    },
    {
      path: "/main",
      redirect: "/main/home",
      name: RouterNames.mainlayout,
      component: () => import("@/views/mainlayout/main-layout.vue"),
      beforeEnter: ssmRouterGuardService.beforeEnter,
      children: [
        {
          path: "home",
          name: RouterNames.Home,
          component: () => import("@/views/home/home.vue"),
        },
        {
          path: "Dash/:id",
          name: RouterNames.Dash,
          meta: { show_btns: "true" },
          component: () => import("@/views/home/dashboard_by_group.vue"),
        },
        {
          path: "usuarios",
          redirect: "/main/usuarios/lista",
          name: RouterNames.usuarios,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.usuarioslista,
              component: () => import("@/views/usuarios/UsuariosLista.vue"),
              children: [],
            },
          ],
        },
        {
          path: "rol",
          name: RouterNames.rol,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.rollista,
              component: () => import("@/views/roles/RolesLista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.rolformulario,
              component: () => import("@/views/roles/RolesFormulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "tablas",
          name: RouterNames.tablas,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.tablaslista,
              component: () =>
                import(
                  "@/views/dynamic_tables/views_settings/dynamic_tables_lista.vue"
                ),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.tablasformulario,
              component: () =>
                import(
                  "@/views/dynamic_tables/views_settings/dynamic_tables_formulario.vue"
                ),
              children: [],
            },
          ],
        },
        {
          path: "dispositivos",
          name: RouterNames.dispositivos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.dispositivoslista,
              component: () =>
                import("@/views/config_plataforma/dispositivos_lista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.dispositivosformulario,
              component: () =>
                import("@/views/config_plataforma/dispositivo_ficha.vue"),
              children: [],
            },
          ],
        },
        {
          path: "test",
          name: RouterNames.test,
          component: () => import("@/views/pruebas/test.vue"),
          children: [],
        },{
          path: "test_informacion",
          name: RouterNames.test_informacion,
          component: () => import("@/views/pruebas/test_informacion.vue"),
          children: [],
        },
        {
          path: "recursos",
          name: RouterNames.recursos,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.recursoslista,
              component: () =>
                import("@/views/config_plataforma/recursos_lista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.recursosformulario,
              component: () =>
                import("@/views/config_plataforma/recursos_ficha.vue"),
              children: [],
            },
          ],
        },
        {
          path: "sensores",
          name: RouterNames.sensores,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.sensoreslista,
              component: () =>
                import("@/views/config_plataforma/sensores_lista.vue"),
              children: [],
            },
          ],
        },
        {
          path: "dashboards",
          name: RouterNames.dashboards,
          component: () => import("@/components/titulopantalla/titulo.vue"),
          children: [
            {
              path: "lista",
              name: RouterNames.dashboardslista,
              component: () =>
                import("@/views/config_plataforma/dashboards_lista.vue"),
              children: [],
            },
            {
              path: "formulario/:id",
              name: RouterNames.dashboardsformulario,
              component: () =>
                import("@/views/config_plataforma/dashboards_formulario.vue"),
              children: [],
            },
          ],
        },
        {
          path: "notificaciones",
          name: RouterNames.notificaciones,
          component: () =>
            import("@/views/notificaciones/NotificacionesForm.vue"),
        },
        {
          path: "mi_perfil",
          name: RouterNames.mi_perfil,
          component: () => import("@/views/usuarios/MiPerfil.vue"),
        },
        {
          path: "cerrar_session",
          name: RouterNames.cerrar_session,
          component: () => import("@/views/cerrar_session.vue"),
          children: [],
        },
      ],
    },
  ],
});
